import script from "./AnimatedNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimatedNumber.vue?vue&type=script&setup=true&lang=js"

import "./AnimatedNumber.vue?vue&type=style&index=0&id=dd7064c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd7064c8"]])

export default __exports__